export class StoreCacheError extends Error {
    constructor(message?: string) {
        super(message ?? `StoreCacheError: Unknown error`);
        this.name = "StoreCacheError";
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
